// assistantFlyCall.js — the CALL'S THEATER reaches the meet package
// (components/AssistantFlyCallView.js; docs/FLY_MODE.md §3.3).
//
// The theater is a main-layer view; the layer latches at the shell root (a
// home Fly session restored at boot latches it before any call), so the view
// can render BEFORE the call's meet context is folded into the shell — its
// meet functions (meetFlyPages, meetFlyPage, …) are not registered yet. This
// is the one door to them: a name that is not registered answers `undefined`
// quietly (no "not registered" warning on every route), and the parts declare
// `root.meetFly` as their dependency (`childrenDeps` / `textDeps` / …), so
// they re-run once the call has pages — measured live on dev (d5674e131): a
// part whose first run reached the root only through an unregistered name
// subscribed to nothing and never re-ran.
//
// FRANK: self-contained; `this` is the calling element.
export const assistantFlyCallDo = function assistantFlyCallDo(name, ...args) {
  const fns = this && this.context && this.context.functions
  if (!fns || typeof name !== 'string' || typeof fns[name] !== 'function') return undefined
  return this.call(name, ...args)
}

// Escape on the theater gives the call back (the other main-area views each
// own their Escape row; the shell's overlay reader names the main layer as
// the top layer, so the call view underneath never sees the key).
export const assistantFlyCallShortcuts = function assistantFlyCallShortcuts(el) {
  const view = el || this
  if (!view || typeof view.call !== 'function') return () => false
  view.call('listShortcuts')
  const off = view.call('registerShortcut', {
    id: 'assistantFlyCallClose',
    keys: 'escape',
    label: null,
    group: 'shell.headerTabs.dashboard',
    groupOrder: 3,
    order: 9,
    when: (h, root) => {
      const node = view.node
      if (!node || node.isConnected === false) return false
      if (root && (root._canvasSlot || root._canvasSlotSecond)) return false
      return !!view.call('assistantFlyCallDo', 'meetFlyTheaterShown', root)
    },
    run: () => view.call('assistantFlyCallDo', 'meetFlyTheater', false)
  })
  const stop = () => (typeof off === 'function' ? off() : false)
  view.__flyCallShortcutsOff = stop
  return stop
}

// The theater's open page when it is SLIDES (a Presentation ask in the call,
// meet functions/meetFly.js kind 'deck'): the deck view's own model — the
// slides derived HERE from the page's raw spec (this member's grants), the
// slide its asker presents, the deck's own words for the counter and a
// failure. Every key is set (a childrenAs-'state' child reads a missing key
// from the root). null when the open page is not a deck.
export const assistantFlyCallDeck = function assistantFlyCallDeck(root) {
  const p = this.call('assistantFlyCallDo', 'meetFlyPage', root)
  if (!p || p.kind !== 'deck') return null
  const raw = p.raw && typeof p.raw === 'object' ? p.raw : null
  const slides = raw ? this.call('assistantDeckSlidesFor', raw, root).slides : []
  const vm = {
    status: p.status || 'loading',
    error: p.error || null,
    slides,
    // the deck's `slide`: the page's `index` is its place in the theater list
    index: Number(p.slide) || 0,
    notice: null
  }
  const slide = this.call('assistantDeckSlide', vm)
  return {
    key: p.key,
    title: p.title || (raw && typeof raw.title === 'string' ? raw.title : '') || '',
    status: vm.status,
    error: vm.error,
    statusText: this.call('assistantDeckStatus', vm) || '',
    slide: slide || null,
    count: slides.length,
    counter: this.call('assistantDeckCounter', vm) || '',
    canPrev: !!this.call('assistantDeckCanGo', vm, -1),
    canNext: !!this.call('assistantDeckCanGo', vm, 1)
  }
}
